import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import theme from '../../theme';
import { Alert } from '@mui/material';

const ErrorToast = ({ message }) => {
    return (<ThemeProvider theme={theme}>
        <Alert severity="error" variant="filled">
            {message}
        </Alert>
    </ThemeProvider>
    );
};

ErrorToast.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorToast;